var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2 mt-0 pl-0 pt-0"},[_c('data-grid',{ref:"grid",staticClass:"family-missing-boxes",attrs:{"url":_vm.url,"columns":_vm.columns,"title":_vm.title,"actions":_vm.actions,"hideHeader":true,"selectionEnabled":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }